import getWidgetDataForPDFBoards from './get-widget-data-for-pdf-boards';
import getBoardsForPDF from './getBoardsForPDF';

const analyticsService = {
  getBoardsForPDF,
  getWidgetDataForPDFBoards
};

export default analyticsService;
